import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TarifNameService } from '../tarif-name.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tarif-name',
  templateUrl: './tarif-name.component.html',
  styleUrls: ['./tarif-name.component.css'],
  providers: [TarifNameService]
})
export class TarifNameComponent implements OnInit {

  tarifNames: string[];
  loading: boolean = false;

  constructor(
  			  private tarifNameService: TarifNameService,
  			  private router: Router
  			  ) { }

  ngOnInit() {
        this.loading = true;
        this.tarifNameService.getTarifName().subscribe(response=>{this.tarifNames=response['data'];this.loading=false;});	

  }

  add():void {
   		this.router.navigate(['dashboard/tarif-name-crud']);
  }  

  edit(id: any){
    	 this.router.navigate(['dashboard/tarif-name-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/tarifs/tarif-name/tarif-name.component.ts